function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z",
  fill: "#8B8B8B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.0839 2.56737C15.7849 2.25637 15.2629 2.47037 15.2629 2.90137V5.53837C15.2629 6.64437 16.1739 7.55437 17.2799 7.55437C17.9769 7.56237 18.9449 7.56437 19.7669 7.56237C20.1879 7.56137 20.4019 7.05837 20.1099 6.75437C19.0549 5.65737 17.1659 3.69137 16.0839 2.56737Z",
  fill: "#8B8B8B"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.97398 11.3874H12.359C12.77 11.3874 13.104 11.0544 13.104 10.6434C13.104 10.2324 12.77 9.89844 12.359 9.89844H8.97398C8.56298 9.89844 8.22998 10.2324 8.22998 10.6434C8.22998 11.0544 8.56298 11.3874 8.97398 11.3874ZM8.97408 16.3816H14.4181C14.8291 16.3816 15.1631 16.0486 15.1631 15.6376C15.1631 15.2266 14.8291 14.8926 14.4181 14.8926H8.97408C8.56308 14.8926 8.23008 15.2266 8.23008 15.6376C8.23008 16.0486 8.56308 16.3816 8.97408 16.3816Z",
  fill: "#8B8B8B"
});
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.54d94643.svg";
export { ForwardRef as ReactComponent };